import { render, staticRenderFns } from "./add-account-wizard.vue?vue&type=template&id=387e69d0&scoped=true"
import script from "./add-account-wizard.vue?vue&type=script&lang=js"
export * from "./add-account-wizard.vue?vue&type=script&lang=js"
import style0 from "./add-account-wizard.vue?vue&type=style&index=0&id=387e69d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e69d0",
  null
  
)

export default component.exports